<template>
    <div class="header cl">
        <div class="l logo" @click="loginOut">
            <img src="../../assert/images/logo.png"/>
        </div>
        <div class="l time">{{date}} {{dayTime}}好</div>
        <div class="r user_container">
            <el-dropdown @command="handleCommand">
                <div class="user">
                    <img />
                    <span>{{name}}</span>
                </div>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="update">修改密码</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
        <div class="login_out r">
            <a @click="loginOut"></a>
        </div>
        <el-dialog
                title="修改密码"
                :visible.sync="updateDialog">
            <div class="info_content cl">
                <div class="info_line cl mb10">
                    <label class="l">旧密码<span class="red">*</span>：</label>
                    <div class="l inpt"><el-input v-model="oldpassword" type="password" :maxlength="20" placeholder="6-20个字符，区分大小写"></el-input></div>
                </div>
                <div class="info_line cl mb10">
                    <label class="l">新密码<span class="red">*</span>：</label>
                    <div class="l inpt"><el-input v-model="newpassword" type="password" :maxlength="20" placeholder="6-20个字符，区分大小写"></el-input></div>
                </div>
                <div class="info_line cl mb10">
                    <label class="l">确认密码<span class="red">*</span>：</label>
                    <div class="l inpt"><el-input v-model="confirmpassword" type="password" :maxlength="20" placeholder="6-20个字符，区分大小写"></el-input></div>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="updateDialog = false">取 消</el-button>
                <el-button type="primary" @click="updatePsw">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    export default {
        data: function(){
            return {
                date: '2017年12月20日',
                name: '管理员',
                dayTime: '',
                updateDialog: false,
                oldpassword: '',
                newpassword: '',
                confirmpassword: ''
            }
        },
        created: function() {
            let time = new Date()
            let year = time.getFullYear()
            let month = time.getMonth() + 1
            let day = time.getDate()
            let hour = time.getHours()
            this.date = `${year}年${month}月${day}日`
            this.name = localStorage.getItem('userName')
            if (hour < 9){this.dayTime = "早上"} 
            else if (hour < 12){this.dayTime = "中午"} 
            else if (hour < 14){this.dayTime = "中午"} 
            else if (hour < 17){this.dayTime = "下午"} 
            else if (hour < 19){this.dayTime = "傍晚"} 
            else if (hour < 24){this.dayTime = "晚上"}
        },
        methods: {
            loginOut(data) {
                localStorage.setItem('userToken', '')
                this.$router.replace('/')
            },
            handleCommand(command) {
                if (command === 'update') {
                    this.updateDialog = true
                }
            },
            check() {
                let ret = ''
                if (this.oldpassword === '') {
                    ret = '请输入旧密码'
                } else if (this.newpassword === '') {
                    ret = '请输入新密码'
                } else if (this.confirmpassword === '') {
                    ret = '请输入确认密码'
                } else if (this.oldpassword.length < 6 || this.oldpassword.length > 20) {
                    ret = '请输入6-20位字符的旧密码'
                } else if (this.newpassword.length < 6 || this.newpassword.length > 20) {
                    ret = '请输入6-20位字符的新密码'
                } else if (this.newpassword !== this.confirmpassword) {
                    ret = '新密码与确认密码不一致'
                }
                return ret
            },
            updatePsw() {
                let _this = this
                let msg = _this.check()
                if (msg === '') {
                    _this.$http.post('/platserv/platAccount/updatePwd', {
                        oldpassword: _this.oldpassword,
                        newpassword: _this.newpassword
                    }).then(res => {
                        if (res.data.resp_data === 'ok') {
                            _this.$message.success('修改密码成功！')
                            _this.updateDialog = false
                        }else {
                            _this.$message.success('修改密码失败！')
                        }
                    }).catch(error => {
                        let msg = (error.body && error.body.error_code) || error.statusText || error
                        _this.$message.error(msg)
                    })
                } else {
                    _this.$message.warning(msg)
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Index.vue?878b739c